import { render, staticRenderFns } from "./WonderStrategyDetail.vue?vue&type=template&id=0d6ed2b2&scoped=true"
import script from "./WonderStrategyDetail.vue?vue&type=script&lang=js"
export * from "./WonderStrategyDetail.vue?vue&type=script&lang=js"
import style0 from "./WonderStrategyDetail.vue?vue&type=style&index=0&id=0d6ed2b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d6ed2b2",
  null
  
)

export default component.exports